import { render, staticRenderFns } from "./checkout-card.vue?vue&type=template&id=235439d3&scoped=true"
import script from "./checkout-card.vue?vue&type=script&lang=js"
export * from "./checkout-card.vue?vue&type=script&lang=js"
import style0 from "./checkout-card.scss?vue&type=style&index=0&id=235439d3&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235439d3",
  null
  
)

export default component.exports